import React, { FC, ReactNode, useMemo } from "react";
import { LocaleStringContext } from "./LocaleStringContext";
import { NumberFormatContext } from "./NumbeFormatContext";
import { LocaleContext } from "./LocaleContext";

const numberFormat_no = new Intl.NumberFormat("nb-NO");
const numberFormat_en_us = new Intl.NumberFormat("en-US");

export interface LocaleProviderProps {
  locale: string;
  children: ReactNode;
}

export const LocaleProvider: FC<LocaleProviderProps> = (props) => {
  const localeString = consolidateToIntlSupportedLocale(props.locale);
  const locale = useMemo(() => {
    return new Intl.Locale(localeString);
  }, [localeString]);

  const numberFormatter = useMemo(() => {
    if (locale.language === "en-US") {
      return numberFormat_en_us;
    } else if (locale.language === "nb-NO") {
      return numberFormat_no;
    } else if (locale.language === "nn-NO") {
      return numberFormat_no;
    }
    return numberFormat_no;
  }, [locale]);

  return (
    <LocaleStringContext.Provider value={localeString}>
      <LocaleContext.Provider value={locale}>
        <NumberFormatContext.Provider value={numberFormatter}>
          {props.children}
        </NumberFormatContext.Provider>
      </LocaleContext.Provider>
    </LocaleStringContext.Provider>
  );
};

const consolidateToIntlSupportedLocale = (locale: string): string => {
  if (locale === "nn-NO") {
    return "nb-NO";
  } else {
    return locale;
  }
};
